// "Forgot your username?" (olene-platform services/account/src/forgotUsername.ts). The Olene account
// service emails the username to the account's verified email. The answer is the same whether or not
// an account exists, so nothing here learns anything about an account.
import { IS_DEV } from "../stage";

export const ACCOUNT_URL = IS_DEV ? "https://account.dev.olenesoft.com" : "https://account.olenesoft.com";

export async function forgotUsername(email) {
  const res = await fetch(`${ACCOUNT_URL}/api/public/forgot-username`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ email, app: "payclear" }),
  });
  if (res.ok) return;
  // Mapped by messageFor: 429 is the rate limit; anything else is a plain failure.
  throw Object.assign(new Error("forgot-username failed"), {
    code: res.status === 429 ? "TooManyRequestsException" : "ForgotUsernameFailed",
  });
}
